define('presentation/common/conversationImagesGrid/conversationImagePresentationObject',[], function() {
    return function() {
        const self = this;

        self.contentType = ko.observable();
        self.src = ko.observable(null);
    };
});
